"use client";

import React, { useEffect, useRef, useState } from "react";
import "./styles.scss";

type TrustpilotVariant = "mini" | "microStar";

interface TrustpilotProps {
  variant?: TrustpilotVariant;
}

const TrustpilotMini = ({ trustBoxRef }: { trustBoxRef: React.RefObject<HTMLDivElement> }) => {
  return (
    <div
      ref={trustBoxRef}
      className="trustpilot-widget trustBox-mini"
      data-locale="en-US"
      data-template-id="53aa8807dec7e10d38f59f32"
      data-businessunit-id="64f888eb7b782062676ccb0d"
      data-style-height="115px"
      data-style-width="100%"
      data-font-family="Nunito Sans"
      data-testid="trustpilot-widget"
    >
      <a
        href="https://www.trustpilot.com/review/qrcreator.com"
        target="_blank"
        rel="noopener"
      ></a>
    </div>
  );
};

const TrustpilotMicroStar = ({ trustBoxRef }: { trustBoxRef: React.RefObject<HTMLDivElement> }) => {
  return (
    <div
      ref={trustBoxRef}
      className="trustpilot-widget trustBox-micro-star"
      data-locale="en-US"
      data-template-id="5419b732fbfb950b10de65e5"
      data-businessunit-id="64f888eb7b782062676ccb0d"
      data-style-height="38px"
      data-font-family="Nunito Sans"
      data-testid="trustpilot-widget-micro-star"
    >
      <a
        href="https://www.trustpilot.com/review/qrcreator.com"
        target="_blank"
        rel="noopener"
      ></a>
    </div>
  );
};

export const Trustpilot = ({ variant = "mini" }: TrustpilotProps) => {
  const ref = useRef(null);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    let retryCount = 0;
    const maxRetries = 9;
    const retryDelay = 500;

    const loadTrustpilotWidget = () => {
      if (!ref.current) {
        return false;
      }

      if (typeof window.Trustpilot?.loadFromElement !== "function") {
        if (retryCount < maxRetries) {
          retryCount++;
          timeoutId = setTimeout(loadTrustpilotWidget, retryDelay);
        } else {
        }
        return false;
      }

      try {
        window.Trustpilot.loadFromElement(ref.current, true);
        setIsInitialized(true);
        return true;
      } catch {
        return false;
      }
    };

    loadTrustpilotWidget();

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, []);

  const WidgetComponent = variant === "microStar" ? TrustpilotMicroStar : TrustpilotMini;

  return (
    <div
      style={{ visibility: isInitialized ? "visible" : "hidden" }}
      className={`trustpilot__wrapper trustpilot__wrapper--${variant}`}
    >
      <WidgetComponent trustBoxRef={ref} />
    </div>
  );
};
